import api from "@/assets/js/api.js";

export function apiGetLang(data) {
  return api({
    url: `locales/${data.currentLocale}-v50.json`,
    type: "GET",
    data,
  });
}
